import { useCallback, useEffect, useState } from 'react';

import { toggleGenesysWidgetVisibility } from '../utils.js';

interface UseSurveyOverlayReturn {
  isOverlayVisible: boolean;
  openOverlay: () => void;
  closeOverlay: () => void;
}

export const useSurveyOverlay = (): UseSurveyOverlayReturn => {
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);

  const openOverlay = useCallback(() => {
    setIsOverlayVisible(true);
    toggleGenesysWidgetVisibility(false);
  }, []);

  const closeOverlay = useCallback(() => {
    setIsOverlayVisible(false);
    toggleGenesysWidgetVisibility(true);
  }, []);

  useEffect(() => {
    if (!isOverlayVisible) {
      return;
    }

    // Escape key handler
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        closeOverlay();
      }
    };

    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('keydown', handleEscape);
      toggleGenesysWidgetVisibility(true);
    };
  }, [isOverlayVisible, closeOverlay]);

  return {
    isOverlayVisible,
    openOverlay,
    closeOverlay,
  };
};
